<!--
 * @Author: Junjie
 * @Date: 2022-08-19 16:34:29
 * @LastEditTime: 2022-08-22 00:35:33
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/alert/modules/AlertLifeCycleModal.vue
-->

<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    cancelText="关闭"
    switchFullscreen
  >
    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      class="j-table-force-nowrap"
    >
      <span slot="summarySlot" slot-scope="text, record">
        <span v-if="record.actionType === 'publish'" style="margin-left:10px;">{{ text || alert.summary }}</span>
        <span v-else style="margin-left:10px;">{{ text }}</span>
      </span>
    </a-table>
  </j-modal>
</template>

<script>
import { getAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'AlertLifeCycleModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {},
  data() {
    return {
      title: '告警日志',
      width: 1000,
      visible: false,
      disableSubmit: true,
      alert: {},
      queryParam: { alertId: '-' },
      dataSource: [],
      url: {
        list: '/alert/iotAlertLifecycle/list'
      },
      isorter: {
        column: 'actionTime',
        order: 'asc'
      },
      columns: [
        {
          title: '时间',
          align: 'center',
          sorter: true,
          dataIndex: 'actionTime'
        },
        {
          title: '变化类型',
          align: 'center',
          dataIndex: 'actionType_dictText'
        },
        {
          title: '操作人',
          align: 'center',
          dataIndex: 'actionPerson'
        },
        {
          title: '详情',
          dataIndex: 'actionDetail',
          scopedSlots: { customRender: 'summarySlot' }
        }
      ]
    }
  },
  methods: {
    created() {
      this.getSuperFieldList()
    },
    show(record) {
      this.visible = true
      this.alert = record
      this.queryParam.alertId = record.id
      this.$nextTick(() => {
        this.loadData()
      })
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'datetime', value: 'acttionTime', text: '动作时间' })
      fieldList.push({ type: 'string', value: 'actionType', text: '动作', dictCode: '' })
      fieldList.push({ type: 'string', value: 'actionPerson', text: '动作人', dictCode: '' })
      this.superFieldList = fieldList
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
